import React from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../assets/styles/style';
import { Footer } from '../assets/styles/clean';

import { IS_APP } from '../services/target';

const Clean = ({ page, siteClassName, siteName }) => (
  <section id="main" className={`clean ${siteClassName} ${IS_APP ? '_target-app' : ''}`}>
    <Route component={page} />
    {!IS_APP && <Footer>&copy; 2019 {siteName} - Todos os direitos Reservados.</Footer>}
  </section>
);

Clean.propTypes = {
  page: PropTypes.func.isRequired,
  siteClassName: PropTypes.string.isRequired,
  siteName: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  siteClassName: `__${state.sites.data.name.toLowerCase()}`,
  siteName: state.sites.data.name,
});

export default connect(mapStateToProps)(Clean);



// WEBPACK FOOTER //
// ./src/layouts/clean.js